function Field({ label, name, value, onChange, required, type = "text", placeholder, testId }) {
  return (
    <div>
      <label className="field-label">
        {label}
        {required ? " *" : ""}
      </label>
      <input
        type={type}
        required={required}
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        className="field"
        placeholder={placeholder}
        data-testid={testId}
      />
    </div>
  );
}

export default function LeadFormBasicFields({ data, set }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      <Field label="Vorname" name="first_name" value={data.first_name} onChange={set} required testId="input-first-name" />
      <Field label="Nachname" name="last_name" value={data.last_name} onChange={set} required testId="input-last-name" />
      <Field label="Unternehmen" name="company" value={data.company} onChange={set} testId="input-company" />
      <Field label="Rolle / Funktion" name="role" value={data.role} onChange={set} testId="input-role" />
      <Field label="E-Mail" name="email" value={data.email} onChange={set} required type="email" testId="input-email" />
      <Field label="Telefon" name="phone" value={data.phone} onChange={set} testId="input-phone" />
      <div className="md:col-span-2">
        <Field
          label="Website (optional)"
          name="website"
          value={data.website}
          onChange={set}
          placeholder="https://"
          testId="input-website"
        />
      </div>
    </div>
  );
}
